export const UtilHtmlElementWhen = wcardinal.ui.UtilHtmlElementWhen;